import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { connect } from 'react-redux';
import { Row, Col } from 'react-bootstrap';
import { compose } from 'utils/react';
import { fromNamed } from 'utils/colors';
import CurrentSiteContext from 'modules/react/contexts/CurrentSiteContext';
import styles from './Banner.scss';
import FullWidth from './FullWidth';
import Ribbon from './Ribbon';

export const FULLWIDTH = 'FULLWIDTH';
export const RIBBON = 'RIBBON';

class BannerInput extends React.Component {
  static propTypes = {
    input: PropTypes.shape({
      value: PropTypes.string,
      onChange: PropTypes.func.isRequired,
    }),
    colorValue: PropTypes.string,
  };

  handleClickFullWidth = () => {
    this.props.input.onChange(FULLWIDTH);
  };

  handleClickRibbon = () => {
    this.props.input.onChange(RIBBON);
  };

  render() {
    const { input, colorValue } = this.props;
    return (
      <CurrentSiteContext.Consumer>
        {({ theme }) => (
          <div>
            <Row>
              <div className={`${styles.description} ${styles.title}`}>Select the style of banner you want</div>
              <Col
                xs={6}
                className={input.value === FULLWIDTH ? '' : styles.nonSelected}
                onClick={this.handleClickFullWidth}
              >
                <div className={styles.banner}>
                  <FullWidth color={fromNamed(theme.colors, colorValue)} />
                </div>
                <div className={styles.styleOption}>Full width</div>
              </Col>
              <Col
                xs={6}
                className={input.value === RIBBON ? '' : styles.nonSelected}
                onClick={this.handleClickRibbon}
              >
                <div className={styles.banner}>
                  <Ribbon color={fromNamed(theme.colors, colorValue)} />
                </div>
                <div className={styles.styleOption}>Ribbon edges</div>
              </Col>
            </Row>
          </div>
        )}
      </CurrentSiteContext.Consumer>
    );
  }
}

export default compose(
  connect(
    ({ form }) => ({
      colorValue: get(form, 'Banner-section-modal.values.color'),
    }),
  ),
)(BannerInput);
